import { translate as i18n } from "@/i18n";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let firebaseServicesPromise = null;
let activeAuth = null;

export const getFirebaseServices = () => {
  if (!firebaseServicesPromise) {
    firebaseServicesPromise = Promise.all([
      import("firebase/app"),
      import("firebase/auth"),
    ]).then(([firebaseAppApi, authApi]) => {
      const firebaseApp = firebaseAppApi.getApps()[0] || firebaseAppApi.initializeApp(config);
      const auth = authApi.getAuth(firebaseApp);
      const googleProvider = new authApi.GoogleAuthProvider();
      googleProvider.setCustomParameters({ prompt: "select_account" });
      activeAuth = auth;
      return { firebaseApp, auth, googleProvider, authApi };
    });
  }
  return firebaseServicesPromise;
};

export const getActiveFirebaseAuth = () => activeAuth;

export const getFirebaseAuth = async () => {
  const { auth } = await getFirebaseServices();
  return auth;
};

export const getFirebaseIdToken = async (forceRefresh = false) => {
  const firebaseUser = activeAuth?.currentUser;
  return firebaseUser ? firebaseUser.getIdToken(forceRefresh) : null;
};

export const firebaseErrorMessage = (error, fallback = i18n("ui.lib_firebase.operationFailed")) => {
  const messages = {
    "auth/email-already-in-use": i18n("ui.lib_firebase.ya_existe_una_cuenta_con_este_email"),
    "auth/invalid-email": i18n("ui.lib_firebase.el_email_no_es_valido"),
    "auth/invalid-credential": i18n("ui.lib_firebase.email_o_contrasena_incorrectos"),
    "auth/user-disabled": i18n("ui.lib_firebase.esta_cuenta_esta_desactivada"),
    "auth/weak-password": i18n("ui.lib_firebase.la_contrasena_no_cumple_la_politica_de_seg"),
    "auth/too-many-requests": i18n("ui.lib_firebase.demasiados_intentos_intentalo_de_nuevo_mas"),
    "auth/popup-closed-by-user": i18n("ui.lib_firebase.se_cerro_la_ventana_antes_de_terminar"),
    "auth/popup-blocked": i18n("ui.lib_firebase.el_navegador_bloqueo_la_ventana_de_acceso"),
    "auth/account-exists-with-different-credential": i18n("ui.lib_firebase.ya_existe_una_cuenta_con_este_email_usando"),
    "auth/invalid-action-code": i18n("ui.lib_firebase.el_enlace_no_es_valido_o_ya_se_utilizo"),
    "auth/expired-action-code": i18n("ui.lib_firebase.el_enlace_ha_caducado_solicita_uno_nuevo"),
    "auth/requires-recent-login": i18n("ui.lib_firebase.por_seguridad_vuelve_a_iniciar_sesion_ante"),
    "auth/wrong-password": i18n("ui.lib_firebase.la_contrasena_actual_no_es_correcta"),
  };
  return messages[error?.code] || fallback;
};
